export default __webpack_public_path__ + "static/media/Sash of the Bloodhunter (nm).5f283309.jpg";